<template>
  <div class="resultCard">
    <div class="tips-box">
      <p class="tips">{{ $t("completed") }}</p>
      <p class="tips">{{ $t("claimYourRewards") }}</p>
    </div>
    <div class="select-box">
      <!-- 服务器选择 -->
      <select
        class="select server-select"
        @change="changeServerIndex"
        v-model="serverIndex"
      >
        <option
          :value="sIndex"
          v-for="(sItem, sIndex) in serverList"
          :key="sIndex"
        >
          {{ sItem.sname }}
        </option>
      </select>
      <!-- 角色选择 -->
      <select
        class="select char-select"
        v-model="roleIndex"
        @change="changeRoleIndex"
      >
        <option
          :value="rIndex"
          v-for="(rItem, rIndex) in roleList"
          :key="rIndex"
        >
          {{ rItem.roleName }}
        </option>
      </select>
    </div>
    <a href="javascript:void(0)" class="claimBtn" @click="getSurveyAward">{{
      $t("confirm")
    }}</a>
  </div>
</template>
<script setup>
import resultHook from "@/hooks/resultHook";
import { useStore } from "vuex";
import { computed } from "vue";
import { SET_ROLE_INDEX } from "../../store/modules/user/mutations";
import { SET_SERVER_INDEX } from "../../store/modules/user/actions";
const store = useStore();
const { getSurveyAward } = resultHook();
const serverList = computed(() => store.state.user.serverList);
const roleList = computed(() => store.state.user.roleList);
const serverIndex = computed(() => store.state.user.serverIndex);
const roleIndex = computed(() => store.state.user.roleIndex);
const changeServerIndex = (e) => {
  store.dispatch(`user/${SET_SERVER_INDEX}`, e.target.value);
};
const changeRoleIndex = (e) => {
  store.commit(`user/${SET_ROLE_INDEX}`, e.target.value);
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixin.scss";
.resultCard {
  .select-box {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    background: #fff;
    width: 600px;
    height: 200px;
    margin-top: 20px;
    border-radius: 10px;
  }
  .select {
    outline: none;
    appearance: none;
    font-size: 20px;
    background: #efefef;
    border-radius: 10px;
    border: 1px solid #ece8e8;
    height: 70px;
    width: 90%;
    box-sizing: border-box;
    padding-left: 20px;
    color: #333;
    @media (orientation: landscape) {
      font-size: 20px;
      border-radius: 10px;
      border: 1px solid #ece8e8;
      height: 60px;
      padding-left: 20px;
    }
  }
  .claimBtn {
    display: flex;
    width: 600px;
    height: 80px;
    align-items: center;
    justify-content: center;
    background: $btnColor;
    color: #fff;
    transition: all 0.4s;
    border-radius: 10px;
    font-size: 22px;
    margin: 60px 0;
    flex-shrink: 0;
    @media (orientation: landscape) {
      width: 350px;
      height: 70px;
      border-radius: 100px;
      font-size: 22px;
      margin: 60px 0;
    }
    &:hover {
      filter: brightness(1.1);
    }
  }
}
</style>
